import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll on route change so a switch from "/people" → "/offices"
// doesn't dump the user halfway down the new page. When the target carries a
// hash (e.g. footer "Practice" → /practice#practice-III), scroll that anchor
// into view instead — scroll-padding-top offsets the sticky topbar, and each
// .practice-row is a snap point so mandatory scroll-snap doesn't fight the jump.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    let cancelled = false;
    const jump = () => {
      if (cancelled) return;
      const el = document.getElementById(hash.slice(1));
      if (!el) { window.scrollTo({ top: 0, behavior: 'auto' }); return; }
      // Briefly suspend scroll-snap: under `mandatory` the browser snaps mid-way
      // through a programmatic scroll and can stop short of the target. With snap
      // off, scrollIntoView lands exactly (scroll-padding-top offsets the topbar);
      // since the row is itself a snap point, restoring snap keeps it in place.
      const root = document.documentElement;
      const prevSnap = root.style.scrollSnapType;
      root.style.scrollSnapType = 'none';
      el.scrollIntoView({ block: 'start' });
      requestAnimationFrame(() => { if (!cancelled) root.style.scrollSnapType = prevSnap; });
    };

    // Wait for web fonts before measuring, so an initial deep-link doesn't scroll
    // against a pre-font layout that then reflows out from under it.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => { if (!cancelled) requestAnimationFrame(jump); });
    } else {
      requestAnimationFrame(jump);
    }
    return () => { cancelled = true; };
  }, [pathname, hash]);
  return null;
}
